module.exports = __webpack_public_path__ + "img/Investment.4cfee4fa.svg";